<template>
  <div>
    <div v-bind:class="{'main-content': !inModal}" v-if="!hardRefresh">
      <div class="card">
        <div class="card-header">
          <h5>{{ refund ? 'Возврат заявки' : 'Обработка заявки' }} <strong>{{ $route.params.id || orderId }}</strong>
            <span class="red" v-if="$editNewOrder.type_id === 2">(возврат {{ $editNewOrder.related_order_id }})</span>
            <span v-bind:class="{
            'badge': true,
            'badge-dark': [0,9999].includes(+$editNewOrder.status),
            'badge-info': [1,2,8].includes(+$editNewOrder.status),
            'badge-success': [3,11].includes(+$editNewOrder.status),
            'badge-warning': [-2,-3].includes(+$editNewOrder.status),
          }" v-if="!refund">
            {{ $editNewOrder.status_label }}</span>
            <span class="badge badge-danger" v-if="$editNewOrder.site_mirror_id">{{
                getMirrorName($editNewOrder)
              }}</span>
            <span v-if="$editNewOrder.status === 9" class="badge badge-info">заявка предварительная и не учавствует в просчетах</span>
          </h5>
        </div>
        <div class="card-body">
          <div class="alert alert-danger"
               v-if="$editNewOrder.status === 0 && isOrderUnderManagerProgress($editNewOrder.id) && +isOrderUnderManagerProgress($editNewOrder.id, true) !== $currentUID">
            <OrderInProgressByManager :order-id="$editNewOrder.id"/>
          </div>
          <div class="row">
            <div class="col-md-12">
              <template v-if="$editNewOrder.id">
                <SelectProjectCity
                  :onUpdate="(data) => this.updateLocality(data)"
                />
              </template>
            </div>
            <div class="col-md-4" v-if="$editNewOrder.status === 3 && mixinIsAllowToView('orderSaleData')">
              <SaleData
                :order="$editNewOrder"
              />
            </div>
          </div>
        </div>
      </div>
      <div class="card">
        <div class="card-header">
          <h5>Клиент</h5>
        </div>
        <div class="card-body">
          <SelectClient ref="clientData"
                        :selectedPhones="$editNewOrder.order_phones"
          />
        </div>
      </div>

      <div class="card"
           v-if="$editNewOrder.extra_options?.extra_drugs_display && $editNewOrder.extra_options.extra_drugs_display.length">
        <div class="card-header bg-warning">
          <h6><i class="icon-fa icon-fa-warning"/> В заявке были указаны другие препараты</h6>
        </div>
        <div class="card-body">
          <table class="table table-sm table-hover table_extra_drugs">
            <thead>
            <tr>
              <th></th>
              <th>Препарат</th>
              <th>Кол</th>
              <th>Цена</th>
            </tr>
            </thead>
            <tbody>
            <tr v-for="(drug, i) in $editNewOrder.extra_options.extra_drugs_display" v-if="!drug.drug_id">
              <td>{{ i + 1 }}</td>
              <td>{{ drug.title }}</td>
              <td>{{ drug.qty }}</td>
              <td>{{ drug.price }}</td>
            </tr>
            </tbody>
          </table>
        </div>
      </div>

      <div class="card">
        <div class="card-header">
          <h5>Препараты</h5>
        </div>
        <div class="card-body">
          <div class="row">
            <div class="col-md-8">
              <template v-for="(drug, index) in drugsInOrder">
                <div class="drugSelected" :key="drug.id">
                  <DrugSelect
                    ref="SelectedDrug"
                    :onSelect="(d, hardRefresh = null) => updateDrugData(d, index, hardRefresh)"
                    :combinedDrugs="$editNewOrder.details.filter((d) => d.parent_drug_id === drug.id)"
                    searchType="1"
                    :updateDeliveryDate="() => checkDeliveryDate()"
                    :selectedDrug="drug"
                  />
                  <div class="send_drug_btn_block" v-if="sendDrugMessage">
                    <button @click="() => sendDrugMessage($editNewOrder.drugs[index])"
                            class="btn btn-outline-info btn-xs">Отправить
                      препарат в чат
                    </button>
                  </div>
                </div>
              </template>
              <div class="drugSelected">
                <DrugSelect
                  ref="newDrug"
                  searchType="1"
                  :onSelect="(d) => updateDrugData(d, drugsInOrder.length, true)"
                />
              </div>
            </div>
            <div class="col-md-4">
              <OrderPriceDetails
                ref="OrderPriceDetails"
                :saveOrder="() => updateOrder()"
                :allowToUseCard="allowToUseCardForPrePaid"
              />
            </div>
          </div>
        </div>
      </div>

      <div class="card">
        <div class="card-body">
          <div class="flex flex_gap_10">
            <ReserveOrder ref="ReserveOrder"/>
            <AttachedFiles v-if="($editNewOrder.files ?? []).length" :files="$editNewOrder.files" ref="AttachedFiles"/>
          </div>
        </div>
      </div>

      <div class="card">
        <div class="card-header">
          <h5>Доставка</h5>
        </div>
        <div class="card-body">
          <div v-if="deliveryDateWarning">
            <RecommendedDeliveryDate
              :deliveryDate="$refs.DeliveryData.deliveryDate"
              :cityId="currentLocality.city_id"
            />
          </div>
          <DeliveryData
            ref="DeliveryData"
            :checkDeliveryDate="checkDeliveryDate"
          />
        </div>
      </div>

      <CommentBlock ref="commentBlock"/>

      <div class="card" v-if="($editNewOrder.files ?? []).length">
        <div class="card-body">
          <UploadImages :block-upload="true" :files="$editNewOrder.files"/>
        </div>
      </div>

      <div class="card">
        <div class="card-body">
          <template v-if="adminEditOrder">
            <div class="flex">
              <div class="form-group">
                Статус заявки
                <select v-model="$editNewOrder.status" @change="statusUpdated" class="form-control">
                  <option v-for="(status, id) in $statusTitles" :value="id">{{ status }}</option>
                </select>
              </div>
              <template v-if="[-2,-3].includes(+$editNewOrder.status)">
                <div class="form-group ml-1">
                  Причина отказа
                  <input v-model="$editNewOrder.reject_comment" class="form-control"/>
                </div>
              </template>
              <template v-if="[2,-3,3].includes(+$editNewOrder.status)">
                <div class="form-group ml-1">
                  Курьер
                  <select v-model="$editNewOrder.runner_id" class="form-control">
                    <option v-for="(runner, i) in getRunnerByOrder()" :value="runner.id">{{ runner.name }}</option>
                  </select>
                </div>
              </template>
              <template v-if="[-2,-3,3].includes(+$editNewOrder.status)">
                <div class="form-group ml-1">
                  Дата отчета
                  <OrderDateSelect
                    ref="selectedReportDate"
                    :disabledBefore="reportDateDisabledBefore"
                    :disabled="true"
                    :onSelect="date => updateOrderReportDate(date)"
                    :selectedDate="$editNewOrder.report_date"
                  />
                </div>
              </template>
            </div>
            <LoadingButton
              title="Сохранить заявку"
              className="btn btn-success"
              color="white"
              :loading="loadingBtn"
              :onClick="() => updateOrder()"
            />
          </template>
          <template v-else>
            <div v-if="allowToEditOrder" class="flex justify-content-between">
              <div class="min-w-300">
                <template v-if="!refund">
                  <button v-if="!showRejectBlock" @click="showRejectBlock = !showRejectBlock"
                          class="btn btn-outline-warning">Отказ
                  </button>
                  <div v-if="showRejectBlock">
                    <RejectTypeSelect/>
                    <LoadingButton
                      title="Подтвердить отказ"
                      className="btn btn-outline-warning"
                      :color="$constants.WARNING_COLOR"
                      :loading="loadingBtn"
                      :onClick="() => updateOrder(false, true)"
                    />
                  </div>
                </template>
              </div>
              <div class="flex flex_gap_10">
                <LoadingButton
                  title="Отметить заявку как спрос"
                  className="btn btn-outline-info"
                  :loading="loadingBtn"
                  :color="$constants.LOADING_COLOR"
                  :onClick="() => updateOrderCustom()"
                />
                <template v-if="allowToPassDelivery">
                  <LoadingButton
                    title="передать заявку на ФДК"
                    className="btn btn-info"
                    :color="$constants.LOADING_COLOR"
                    :loading="loadingBtn"
                    :onClick="() => updateOrder(false, false, true)"
                  />
                </template>
                <template v-else>
                  <LoadingButton
                    title="Отправить заявку"
                    className="btn btn-info"
                    color="white"
                    :loading="loadingBtn"
                    :onClick="() => updateOrder(true)"
                  />
                </template>
                <LoadingButton
                  title="Сохранить заявку"
                  className="btn btn-success"
                  color="white"
                  :loading="loadingBtn"
                  :onClick="() => updateOrder()"
                />
              </div>
            </div>
            <div v-else class="alert alert-warning">
              <p>Доступ к редактированию заявки - запрещен</p>
              <p v-if="$editNewOrder.status < 0">Причина отказа: {{ $editNewOrder.reject_comment }}</p>
            </div>
          </template>
        </div>
      </div>

      <div class="card">
        <div class="card-header">
          <h5>История</h5>
        </div>
        <div class="card-body">
          <orderTrace
            :trace="this.$editNewOrder.trace"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>

import api from '@/api'
import SelectProjectCity from '@/components/orders/SelectProjectCity'
import SelectClient from '@/components/clients/SelectClient'
import DrugSelect from '@/components/drugs/DrugSelectForOrder'
import OrderPriceDetails from '@/components/orders/OrderPriceDetails'
import DeliveryData from './components/DeliveryData'
import CommentBlock from './components/CommentsBlock'
import LoadingButton from '@/components/buttons/LoadingButton'
import orderTrace from '@/components/orders/trace'
import OrderDateSelect from '@/views/reports/components/OrderDateSelect'
import moment from 'moment'
import SaleData from './components/SaleData'
import OrderNotification from '@/components/notifications/OrderNotification'
import ReserveOrder from "@/components/orders/ReserveOrder.vue";
import RejectTypeSelect from "@/views/orders/components/RejectTypeSelect.vue";
import RecommendedDeliveryDate from "@/views/orders/components/RecommendedDeliveryDate.vue";
import PreviewPage from "@/components/files/PreviewPage.vue";
import UploadImages from "@/components/uploads/UploadImages.vue";
import UserName from "@/components/users/UserName.vue";
import OrderInProgressByManager from "@/views/orders/components/OrderInProgressByManager.vue";
import AttachedFiles from "@/components/orders/files/AttachedFiles.vue";

export default {
  props: ['orderToEdit', 'orderId', 'closeOrder', 'isModal', 'sendDrugMessage'],
  title: 'Редактирование заявки',
  components: {
    AttachedFiles,
    OrderInProgressByManager,
    UserName,
    UploadImages,
    PreviewPage,
    RecommendedDeliveryDate,
    RejectTypeSelect,
    ReserveOrder,
    SelectProjectCity,
    SelectClient,
    DrugSelect,
    OrderPriceDetails,
    DeliveryData,
    CommentBlock,
    LoadingButton,
    orderTrace,
    OrderDateSelect,
    SaleData,
    OrderNotification,
  },
  data() {
    return {
      refund: false,
      deliveryDateWarning: null,
      allowToPassDelivery: false,
      reportDateDisabledBefore: moment().add('-5', 'days').toDate(),
      refundOrderId: null,
      inModal: false,
      savedOrderId: null,
      hardRefresh: true,
      order: {},
      currentLocality: {},
      loadingBtn: false,
      drugsInOrder: [],
      showRejectBlock: false,
      allowToEditOrder: false,
      adminEditOrder: false,
      allowToUseCardForPrePaid: false,
    }
  },
  computed: {
    $AllCurrencies() {
      return this.$store.getters["platform/currencies"];
    },
    $editNewOrder() {
      return this.$store.getters['orders/editNewOrder']
    },
    $statusTitles() {
      return this.$store.getters['orders/statusTitles']
    },
    $AllProjects() {
      const sites = this.$store.getters["platform/projects"].reduce(
        (acc, p) => {
          acc[p.id] = {...p};
          return acc;
        },
        {}
      );
      return sites;
    },
  },
  async created() {
    //set dynamics fields
    this.adminEditOrder = false
    await this.mixinGetOrderRunners()
    await this.initiateOrder()
    if (this.$currentRole === 'admin'
      || this.$currentUserRoles.includes('supervisor')
      || this.$currentUserRoles.includes('chiefManager')
      || this.$currentUserRoles.includes('admin')) {
      if (this.$editNewOrder.status === 3) {
        if (moment().diff(this.$editNewOrder.report_date, 'days') < 15) {
          this.adminEditOrder = true
        }
        if (this.$currentRole === 'admin' && moment().diff(this.$editNewOrder.report_date, 'days') < 180) {
          this.adminEditOrder = true
        }

      } else {
        this.adminEditOrder = true
      }
    } else if (this.$currentUserRoles.includes('manager')
      || this.$currentUserRoles.includes('allProjectsAccess')
      || this.$currentUserRoles.includes('managerAssist')) {
      if ([9999, 0, 8, 9].includes(+this.$editNewOrder.status) || this.refund) {
        // console.log('status pass', this.$orderAccess, this.$editNewOrder.site_id, this.$editNewOrder.city_id);
        if (this.$orderAccess?.all?.all) {
          this.allowToEditOrder = true
        }
        if (this.$orderAccess?.all?.[this.$editNewOrder.city_id]) {
          this.allowToEditOrder = true
        }
        if (this.$orderAccess?.[this.$editNewOrder.site_id]?.all) {
          this.allowToEditOrder = true
        }
        if (this.$orderAccess?.[this.$editNewOrder.site_id]?.[this.$editNewOrder.city_id]) {
          this.allowToEditOrder = true
        }
        // console.log(this.allowToEditOrder);
      }
    }
    this.updateCustomData();
    this.order = {...this.$editNewOrder};
    let divId = this.order.division_id
    if (!divId) {
      const div = Object.values(this.$AllDivisions).find((d) => d.cities.find((c) => c.object_id === +this.order.city_id));
      if (div) {
        divId = div.id;
      }
    }
    if (this.$AllDivisions[divId] && this.$AllDivisions[divId].settings && this.$AllDivisions[divId].settings.use_prepaid_cards) {
      this.allowToUseCardForPrePaid = this.$AllDivisions[divId].settings.credit_cards_type;
    }
    if (this.$editNewOrder.extra_options?.extra_drugs && this.$editNewOrder.extra_options.extra_drugs.length) {
      const drugs = this.$editNewOrder.details.map((d) => d.drug_id);
      this.$editNewOrder.extra_options.extra_drugs_display = this.$editNewOrder.extra_options?.extra_drugs.filter((d) => !drugs.includes(d.drug_id));
      // this.$editNewOrder.extra_options.extra_drugs = this.$editNewOrder.extra_options?.extra_drugs.filter((d) => !drugs.includes(d.drug_id));
    }
  },
  methods: {
    async checkDeliveryDate() {
      this.deliveryDateWarning = null;
      if ([-3, -2, 3].includes(+this.$editNewOrder.status)) return;
      await this.$nextTick();
      (this.$refs.SelectedDrug ?? []).forEach((sd) => {
        if (+sd.qty <= (sd.$refs.drugInfo?.actualStoreQty || 0)) return;
        this.deliveryDateWarning = true;
      })
    },
    updateCustomData() {
      this.allowToPassDelivery = +this.$editNewOrder.status === 0 && +this.$editNewOrder.site_id === 12;
    },
    statusUpdated() {
      if ([-2, -3].includes(+this.order.status) && +this.$editNewOrder.status === 3) {
        this.$editNewOrder.report_date = moment().format('YYYY-MM-DD HH:mm:00');
        toastr['info']('Дата отчета обновлена');
      }
    },
    getMirrorName(order) {
      const mirror = this.$AllProjects[order.site_id].mirrors.find(m => m.id === order.site_mirror_id);
      return mirror && mirror.title || null
    },
    updateOrderReportDate(date) {
      this.$editNewOrder.report_date = moment(date).format('YYYY-MM-DD 10:00:00')
    },
    getRunnerByOrder() {
      return this.$runners.active.reduce((acc, r) => {
        if (r.detail && r.detail.details == this.$editNewOrder.division_id) {
          acc.push(r)
        }
        return acc
      }, [])
    },
    async initiateOrder() {
      this.inModal = !!(this.orderId || this.isModal || false)
      // console.log(this.refundOrderId, this.$route.params.id, this.orderId)
      if (this.refundOrderId || this.orderId || this.$route.params.id) {
        const orderId = this.refundOrderId || this.orderId || this.$route.params.id
        const {data} = await api.index('/new/orders/' + orderId)
        if (data.success) {
          if (this.$route.params.refund) {
            data.order.id = null
            data.order.status = 9999
            this.refund = true
            data.order.type_id = 2
            if (data.order.discount) {
              data.order.discount *= -1;
            }
          }
          const drugs = data.order.details.reduce((acc, d) => {
            if (!d.qty) return acc;
            acc.push({
              ...d.new_drug,
              type_id: d.type_id,
              qty: (this.$route.params.refund ? (d.qty * -1) : d.qty) / +d.pack_set,
              actual_price: d.price,
              currency_price: d.currency_price,
              detail_id: d.id,
              extra_data: d.extra_data ?? {}
            })
            return acc
          }, []);
          await this.$store.dispatch('orders/setEditNewOrder', {
            ...data.order,
            drugs: drugs
          })
          this.drugsInOrder = [...drugs.filter((d) => [0, 2].includes(d.type_id))];
          this.hardRefresh = false
        } else {
          toastr['warning'](data.message || 'Ошибка сервера!')
        }
      }
    },

    updateDrugData(drug, index, hardRefresh = null) {
      console.log('update drug data');
      console.log(drug, index, hardRefresh);
      let drugsInOrder = [...this.drugsInOrder];
      if (!drug || !drug.qty) {
        // console.log('delete');
        // if (!drug) {
        if (drug) {
          const clearedIndex = drugsInOrder.findIndex((d) => d.id === drug.id);
          delete drugsInOrder[clearedIndex]
        } else {
          delete drugsInOrder[index]
        }
        drugsInOrder = drugsInOrder.filter(d => d)
        hardRefresh = true;
      } else {
        if (!drugsInOrder[index]) {
          const selectedDrugId = drugsInOrder.map((d) => d.id)
          // console.log(selectedDrugId, drug.id);
          if (selectedDrugId.includes(drug.id)) return
          this.$refs.newDrug.drug = null
          drugsInOrder.push(drug)
        } else {
          drugsInOrder[index] = drug
        }
      }
      // if (hardRefresh) {
      this.drugsInOrder = [...drugsInOrder];
      // }
      this.$editNewOrder.drugs = [...drugsInOrder];
      this.$refs.OrderPriceDetails.updatePrice();
    },
    updateLocality(data) {
      this.$editNewOrder.city_id = data.city_id
      this.$editNewOrder.site_id = data.site_id
      this.$editNewOrder.site_mirror_id = data.mirror
      this.currentLocality = data
      this.updateCustomData();
    },
    validatePhones() {
      if (!this.$refs.clientData.client.name || !this.$refs.clientData.client.name === 'ФИО - уточнить!') {
        return false;
      }
      if (!this.$refs.clientData.phones.find((p) => p.phone)) {
        return false
      }
      if (this.$refs.clientData.phones.find((p) => p.phone && !p.valid)) {
        return false
      }
      return true
    },
    updateOrderCustom() {
      this.$editNewOrder.status = 8
      this.updateOrder()
    },
    async updateOrder(send = false, reject = false, passToDelivery = false) {
      if (!reject) {
        if (this.$editNewOrder.credit_card_id && +this.$editNewOrder.price !== this.order.price) {
          toastr['warning']('Сумма заявки изменена и была отправлена предоплата, удалите предоплату и обновите данные');
          // return;
        }
      }

      this.loadingBtn = true

      if (!reject && !this.adminEditOrder && !this.validatePhones()) {
        toastr['warning']('Телефоны или имя клиента не валидны!')
        this.loadingBtn = false
        return false;
      }

      await this.$refs.commentBlock.getUnsavedComment()
      if (this.refund) {
        this.$editNewOrder.related_order_id = this.$route.params.id
        if (!this.$refs.commentBlock.newManagerComment && (!this.$refs.commentBlock.commentsForManager || !this.$refs.commentBlock.commentsForManager.length)) {
          toastr['warning']('Укажите причину возврата в комментарий')
          this.loadingBtn = false
          return false;
        }
        this.$editNewOrder.unSavedComments = {
          forManagers: this.$refs.commentBlock.commentsForManager,
          forRunners: this.$refs.commentBlock.commentsForRunner,
        }
      }

      if (send) {
        if (!this.$editNewOrder.city_id && this.$editNewOrder.pay_method !== 3) {
          toastr['warning']('Отплата заявки не подтверждена')
          this.loadingBtn = false
          return false;
        }
        if (!this.$editNewOrder.address) {
          toastr['warning']('Укажите адрес доставки')
          this.loadingBtn = false
          return false;
        }
      }
      if (reject && ((+this.$editNewOrder.reject_type_id === 0 && !this.$editNewOrder.reject_comment) || this.$editNewOrder.reject_type_id === null)) {
        toastr['warning']('Укажите причину отмены заявки')
        this.loadingBtn = false
        return false;
      }
      if (send && this.$refs.DeliveryData.maxOrdersQty <= +(this.$refs.DeliveryData.ordersInProgress)) {
        this.$confirm(
          {
            message: 'Количество заявок в работе превышает лимит, отправить заявку?',
            button: {
              no: 'Отмена',
              yes: 'Отправить'
            },
            callback: confirm => {
              if (confirm) {
                return this.confirmedUpdateOrder(send, reject, passToDelivery);
              } else {
                this.loadingBtn = false
              }
            }
          });
      } else {
        return this.confirmedUpdateOrder(send, reject, passToDelivery);
      }
      return false;
    },
    async confirmedUpdateOrder(send, reject, passToDelivery) {
      const divRate = this.$AllDivisions[this.$editNewOrder.division_id]?.settings?.cross_currency_id ? (this.$AllCurrencies[this.$AllDivisions[this.$editNewOrder.division_id]?.settings?.cross_currency_id]?.rate ?? 1) : 1;
      // console.log(divRate);
      const {data} = await api.post('/new/orders/update', {
        client: this.$refs.clientData.client,
        phones: this.$refs.clientData.phones,
        order: {
          ...this.$editNewOrder, details: [],
          currencyData: this.$refs.OrderPriceDetails.currencyData,
          drugs: (this.$refs.SelectedDrug ?? []).map((d) => {
            return {
              id: d.drug.id,
              title: d.drug.title,
              pack_set: d.drug.pack_set,
              combined_type: d.drug.combined_type,
              qty: +d.qty,
              actual_price: d.actualPrice,
              currency_price: d.drug.currency_price,
              extra_data: d.drug?.extra_data
            }
          })
          // drugs: this.$editNewOrder.drugs.map((d) => {
          //   const clearedDrug = {...d};
          //   delete clearedDrug.prices;
          //   delete clearedDrug.main_keywords;
          //   delete clearedDrug.keywords;
          //   if (divRate !== 1 && !d.detail_id) {
          //     clearedDrug.actualPrice = Math.round(clearedDrug.actualPrice * divRate / 10) * 10;
          //   }
          //   return clearedDrug;
          // })
        },
        send,
        passToDelivery,
        rejectByManager: reject,
      })

      if (data.success) {
        toastr['success']('Сохранено!');
        (this.$refs.SelectedDrug ?? []).forEach((d) => {
          d.allCommentsSaved();
        });
        if (this.refund) {
          this.mixinGoToRouter('editOrder', {id: data.orderId})
          setTimeout(() => {
            this.refund = false
            this.$route.params.refund = false
            this.refundOrderId = data.orderId
            // console.log('init')
            this.initiateOrder()
            this.loadingBtn = false
          }, 500)
          return true;
        }
        if ((passToDelivery || send) && this.inModal) {
          this.$store.dispatch('orders/setOrderToEdit', {})
          // } else {
          //   this.$router.go(-1)
        }
        this.loadingBtn = false
        return true;
      } else {
        toastr['warning'](data.message || 'Ошибка!')
      }
      this.loadingBtn = false
      return false;
    }
  }
}

</script>

<style scoped>
.card {
  margin-bottom: 10px;
}

.min-w-300 {
  min-width: 300px;
}

.table.table_extra_drugs td {
  padding: 3px 10px;
}

.drugSelected {
  border: 1px solid lightgray;
  padding: 10px;
  margin-bottom: 10px;
  position: relative;
}

.card .card-body {
  background-color: #f8f8f8 !important;
}

.card .card-header h6,
.card .card-header h5 {
  font-weight: 700;
}

.send_drug_btn_block {
  position: absolute;
  right: 10px;
  top: 105px;
}
</style>
